import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import PrivateRoute from "Components/PrivateRouter";

import Login from "Views/Login";
import Dashboard from "Views/Dashboard";
import Admin from "Views/Admin";
import Marca from "Views/Marca";
import TipoOperacion from "Views/TipoOperacion";
import Reporte from "Views/Reporte";
import Vista from "Views/Vista";
import Perfil from "Views/Perfil";
import Profile from "Views/Profile";
import KPIs from "Views/KPIs";
import Reportes from "Views/Reportes";
import Notification from "Views/Notification";
import PowerBI from "Views/PowerBI";
import Usuarios from "Views/Usuarios";
import NotFound from "Views/NotFound";
import RNotificacion from "Views/RNotificacion";
import Sondeos from "Views/Sondeos";
import MapaView from "Views/MapaView";
import CatalogoArchivos from "Views/CatalogoArchivos";
import { ThemeProvider } from "styled-components";
import { useSelector } from "react-redux";
import RelUsuariosArchivos from "Views/RelUsuariosArchivos";
import CargaArchivos from "Views/CargaArchivos";
import AuthAtomatico from "Views/AuthAutomatico";
import { checkValidJwt } from "utils";
import { useMemo } from "react";
import { ReportViewer } from "Views/Reportes/viewer/ReportViewer";

export default function Router() {
  const theme = useSelector((state: any) => state.theme);
  const { jwt } = useSelector((state: any) => state.user);
  const isJwtValid = useMemo(() => {
    return jwt && checkValidJwt(jwt);
  }, [jwt]);

  return (
    //@ts-ignore
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route element={<PrivateRoute />}>
            <Route path="/inicio" element={<Dashboard />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/marca" element={<Marca />} />
            <Route path="/tipo-operacion" element={<TipoOperacion />} />
            <Route path="/reporte" element={<Reporte />} />
            <Route path="/vista" element={<Vista />} />
            <Route path="/perfil" element={<Perfil />} />
            <Route path="/kpis" element={<KPIs />} />
            <Route path="/reportes" element={<Reportes />} />
            <Route path="/Notificaciones" element={<Notification />} />
            <Route path="/report/:id/:type" element={<ReportViewer />} />
            <Route path="/powerbi/:id" element={<PowerBI />} />
            <Route path="/AdmUsuarios" element={<Usuarios />} />
            <Route path="/clientes/sondeos" element={<Sondeos />} />
            <Route
              path="/configuracion/catalogo-archivos"
              element={<CatalogoArchivos />}
            />
            <Route
              path="/configuracion/usuarios-archivos"
              element={<RelUsuariosArchivos />}
            />
            <Route
              path="/configuracion/carga-archivos"
              element={<CargaArchivos />}
            />

            <Route path="/clientes/mapa" element={<MapaView />} />
            <Route
              path="/not-found"
              element={<NotFound url={""} statusCode={""} />}
            />
            <Route
              path="/not-autorized"
              element={<NotFound url={"login"} statusCode={"401"} />}
            />
          </Route>

          <Route path="/login" element={<Login />} />
          <Route path="/auth" element={<AuthAtomatico />} />
          <Route path="/notif/" element={<RNotificacion />} />

          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
